import ReactGA from 'react-ga4';

const MEASUREMENT_ID = "AW-16528553808";

export const initGA = () => {
  ReactGA.initialize(MEASUREMENT_ID);
};

// Google Analytics event tracking
export const trackEvent = (category, action, label = null, value = null) => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

// Track CTA clicks
export const trackCTA = (ctaName, section) => {
  ReactGA.event({
    category: 'CTA',
    action: `Click - ${ctaName}`,
    label: `Section - ${section}`
  });
};

// Track form submissions
export const trackFormSubmission = (formName, success) => {
  if (window.gtag) {
    window.gtag('event', 'form_submission', {
      'event_category': 'Form',
      'event_label': formName,
      'value': success ? 1 : 0
    });
  }
};

// Track form field interactions
export const trackFormFieldInteraction = (formName, fieldName, action) => {
  if (window.gtag) {
    window.gtag('event', 'form_field_interaction', {
      'event_category': 'Form',
      'event_label': `${formName}_${fieldName}`,
      'value': action
    });
  }
};

export const trackConsultationClick = () => {
  ReactGA.event({
    category: 'Conversion',
    action: 'Click',
    label: 'Schedule Consultation Button'
  });
}; 